import React from 'react';
import Page from '../../components/Page';
import Footer from '../../components/Footer';
import { flexContainer, wrapper, title, image, rightMargin, listBox } from './LastPageStyle';
import imgService1 from '../../assets/media/wrapper-media1.jpg';
import imgService2 from '../../assets/media/wrapper-media2.jpg';
import imgService3 from '../../assets/media/wrapper-media3.jpg';

const ServiceExcellenceLastPage = () => {
    return (
        <Page fixedPageHeight>
            <div className={flexContainer}>
                <div className={title}>ZMC navigiert Ihr Service-Geschäft zu Service Excellence</div>
                <h2>Wir bauen mit Ihnen das Service-Geschäft profitabel aus</h2>
                <p>
                    Zellweger Management Consultants (ZMC) bietet umfassende Beratungs-, Umsetzungs-, Trainings- &amp;
                    Durchführungsleistungen zur profitablen Entwicklung des Service-Geschäfts.
                </p>
                <div className={wrapper}>
                    <img className={`${image} ${rightMargin}`} src={imgService1} alt="Tablet" />
                    <div className={listBox}>
                        <b>Service-Innovation</b>
                        <ul>
                            <li>360° Service Assessment</li>
                            <li>Geschäftspotenzialanalyse</li>
                            <li>Strategie-Alignment für Neu- &amp; Service-Geschäft</li>
                            <li>Service Excellence-Transformation</li>
                            <li>Geschäftsmodellinnovation</li>
                            <li>Strategien/Konzepte für digitale Plattformen</li>
                            <li>Lebenszyklusorientierte Service-Modelle</li>
                            <li>Service-Portfolio Design &amp; Management</li>
                            <li>Service-Innovation: Value added, smart, digital Services</li>
                            <li>Produkt- &amp; Service Life Cycle Management</li>
                            <li>Preisstrategien, Value Based Pricing</li>
                            <li>Prototypen, Piloten von Services (MVP)</li>
                        </ul>
                    </div>
                </div>
                <div className={wrapper}>
                    <img className={`${image} ${rightMargin}`} src={imgService3} alt="Sercice" />
                    <div className={listBox}>
                        <b>Service-Vermarktung</b>
                        <ul>
                            <li>Assessment Service Marketing &amp; -Vertrieb</li>
                            <li>Go-to market-Konzepte</li>
                            <li>Service- &amp; Dienstleistungsvertrieb</li>
                            <li>Vertriebskonzepte für Value Added &amp; digitale Services</li>
                            <li>Potenzialorientierte Service-Vertriebssteuerung</li>
                            <li>Pilotvermarktung &amp; -ausführung</li>
                        </ul>
                    </div>
                </div>
                <div className={wrapper}>
                    <img className={`${image} ${rightMargin}`} src={imgService2} alt="Service" />
                    <div className={listBox}>
                        <b>Service-Execution</b>
                        <ul>
                            <li>Planungs- &amp; Steuerungskonzepte</li>
                            <li>Ersatzteilmanagement</li>
                            <li>Service- &amp; Ersatzteil-Supply Chain</li>
                            <li>Obsolence Management</li>
                            <li>Service-Partnermanagement</li>
                            <li>Service-Footprint-Optimierung &amp; -Simulation</li>
                            <li>Reifegradabhängige Service-Organisation</li>
                            <li>Service-Prozesse, Lean Service</li>
                            <li>Service-Personalattraktivität</li>
                            <li>Service Training/Academy</li>
                            <li>Service Controlling, Benchmarking</li>
                            <li>Service Control Tower</li>
                            <li>Digital Service, Service 4.0</li>
                            <li>Evaluation, Implementierung von digitalen Service-Lösungen</li>
                        </ul>
                    </div>
                </div>
                <h2>Namhafte Kunden vertrauen uns</h2>
                <p>
                    Nationale &amp; internationale Industrieunternehmen wählen uns als Partner, um für sie die
                    profitable Entwicklung des Service-Geschäfts erfolgreich zu bewältigen.
                </p>
                <div style={{ flex: 1 }} />
                <Footer />
            </div>
        </Page>
    );
};

export default ServiceExcellenceLastPage;
